<template>
    <div>
        <div v-if="isPc==true" class="breadcrumb greyfont warp">
            <div v-for="(item,index) in breadcrumb" :key="index">
                {{ item }}
                <span v-if="breadcrumb.length - index > 1">》</span>
            </div>
        </div>
        <div :class="isPc==true?'content warp':''">
            <HospitalGUI v-if="isPc==true"></HospitalGUI>
            <div class="content_left">
                <div :class="isPc==true?'tabar_bg':'tabar_bg-mob'">
                    <p>{{title}}</p>
                </div>

                <div v-if="data" :class="isPc==true?'content_left_cont greyfont':'content-mob warp-mob'">
                    <div>
                        <h1>{{ data.title }}</h1>
                        <h2 :class="isPc==true?'':'greyfont'">发布时间：{{ data.createtime }}</h2>
                        <p v-html="data.textcontent"></p>
                    </div>
                </div>

                <!-- <div v-if="isPc==true" class="pagecut">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="1000"
                        page-size='5'>
                    </el-pagination>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    import HospitalGUI from '../components/HospitalGUI.vue';

    export default {
        name: 'WebLijinhospitalContent',
        components: {
            HospitalGUI,
        },
        data() {
            return {
                title: '',
                isPc: true,
                breadcrumb: [],
                data: null,
                id: 0,
            };
        },

        mounted() {
            if (document.body.clientWidth <= 820) {
                this.isPc = false;
                console.log(this.isPc);
            } else {
                this.isPc = true;
                console.log(this.isPc);
            }
            console.log(this.$route.query.title);
            this.title = this.$route.query.title;
            this.breadcrumb.unshift(this.$route.query.title);
            // 文章
            this.id = this.$route.query.id;
            this.getdata();
        },

        methods: {
            getdata() {
                this.$axios({
                    url: 'http://www.ljxzxyy.cn/api/index/article',
                    params: {
                        id: this.id,
                    },
                })
                    .then((res) => {
                        //请求成功
                        console.log('article', res.data);
                        this.data = res.data.data;
                    })
                    .catch((error) => {
                        //请求失败
                        console.log('article', error);
                    });
            },
        },
    };
</script>

<style scoped>
    .content {
        position: relative;
        min-height: 930px;
    }
    .content_left .pagecut {
        width: 950px;
        position: absolute;
        bottom: 0;
    }
    .content_left_cont {
        width: 950px;
    }
    .content_left_cont div {
        width: 95%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .content_left_cont div h1 {
        font-size: 18px;
        height: 60px;
        display: flex;
        align-items: center;
    }
    .content_left_cont div h2 {
        font-weight: normal;
    }
    .content_left_cont div p {
        line-height: 30px;
        margin-top: 40px;
        font-size: 16px;
    }
    .content-mob div {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .content-mob div h1 {
        text-align: center;
        margin-top: 0.3rem;
        font-size: 0.2rem;
    }
    .content-mob div h2 {
        margin-top: 0.1rem;
        font-weight: normal;
        font-size: 0.16rem;
    }
    .content-mob div p {
        margin-top: 0.1rem;
        font-size: 0.18rem;
        line-height: 0.3rem;
    }
</style>
